import { Message, MessageCallback, ResponseCallback, ISessionCloseMessage } from '@augloop/session-protocol';
import { CorrelationVector } from '@augloop/logging/dist/src/client/logging';
import { IClientMetadata } from '@augloop/schemas/dist/src/client/schemas';
import { ISchemaObject } from '@augloop/types-core';
import { SessionConnectCallback } from '../isession';

export type SetSessionDataCallback = (sessionUrl: string, origin: string, authToken: string) => void;

export type GetAuthToken = () => Promise<string>;

export interface ISessionManager {
    init(extensionConfigs: ISchemaObject[], customInitPromise?: () => Promise<void>): Promise<void>;
    sendMessage(message: Message, onResponse?: ResponseCallback): void;
    sendBytes(buffer: Uint8Array): void;
    onMessage(messageType: string, messageCallback: MessageCallback): void;
    getCorrelationVector(): CorrelationVector;
    forceReconnect(extensionConfigs?: ISchemaObject[]): Promise<void>;
    closeSession(): void;
    on(event: 'connect', callback: SessionConnectCallback): void;
    on(event: 'disconnect', callback: (error: string) => void): void;
    on(event: 'reconnect' | 'resetNextSyncSequenceId', callback: () => void): void;
    on(event: 'sessionClose', callback: (sessionCloseMessage: ISessionCloseMessage) => void): void;
}

export class SessionStats {
    /** When was last time connection was closed. Time in UTC timezone, milliseconds elapsed between 1 January 1970 00:00:00 UTC and current time. */
    public lastConnectionClose: number;
    /** When was last time sync message was sent. Time in UTC timezone, milliseconds elapsed between 1 January 1970 00:00:00 UTC and current time. */
    public lastSyncMessage: number;
}
export type SessionManagerFactory = (clientMetadata: IClientMetadata) => ISessionManager;
